module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dashboard-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('scheduled-post-list', {
    attrs: {
      "channels": _vm.socialChannels,
      "posts": _vm.scheduledMessages
    },
    on: {
      "newPost": _vm.onAddNewPost,
      "editPost": _vm.onEditPost,
      "deletePost": _vm.onDeleteScheduledPost
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('social-post-calendar', {
    attrs: {
      "channels": _vm.socialChannels,
      "posts": _vm.scheduledMessages
    },
    on: {
      "newPost": _vm.onAddNewPost,
      "editPost": _vm.onEditPost
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', [_vm._v("Scheduled Posts")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77a38aa0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/SocialScheduleDashboard.vue
// module id = 3347
// module chunks = 3